export default __webpack_public_path__ + "static/media/srisailamHistoryOne.1ea61ccf.jpg";